// extracted by mini-css-extract-plugin
export default {"overlay":"rC-z","bodyOpen":"sC-z","content":"tC-z","header":"uC-z","close":"vC-z","closeNoHeading":"wC-z"};